import styled from '@emotion/styled';
import * as React from 'react';

import { Logo } from '@travelnest/hui';
import theme from '@travelnest/merlin.theme';

const backgroundStyles = {
	'empty': '',
	'house': `
		opacity: 0.25;
		background-image: url('/92b3b47/assets/images/FTUX_House.svg');
		background-size: auto 100%;
		background-repeat: no-repeat;
		background-position: bottom center;
	`,
	'green-blob': `
		opacity: 0.15;
		background-image: url('/92b3b47/assets/images/green-blob.svg');
		background-size: 33rem auto;
		background-repeat: no-repeat;
		background-position: bottom -17rem right -10rem;
	`,
};

const PageBody = styled.div`
	display: flex;
	flex-direction: column;
	min-height: 100vh;
	align-items: center;
	justify-content: center;

	/* @media only screen and (min-width: 760px) {
		flex-direction: row;
	} */
`;

const PageWrapper = styled.div<{ bg: string }>`
	padding: 0 ${theme.layout.spacing.standard};
	flex-grow: 1;
	position: relative;
	width: 100%;
	max-width: calc(calc(${theme.layout.container.maxWidth} + ${theme.layout.spacing.smaller}) / 2);
	border: 1px solid #C9CED9;
	border-radius: 16px;

	&::before,
	&::after {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		border-radius: ${theme.layout.radius.squared};
	}

	&::before {
		z-index: -1;
		${({ bg }) => bg};
	}

	&::after {
		z-index: -2;
		background-color: ${theme.colours.background.lighter};
	}

	@media only screen and (min-width: 760px) {
		max-height: 700px;
	}
`;

const PageHeaderContent = styled.div`
	width: 100%;
	max-width: ${theme.layout.container.maxWidth};
	margin: auto;
	padding: ${theme.layout.spacing.smaller} 0;
	display: flex;
	justify-content: space-between;
`;

const BottomWrapper = styled.div`
	width: calc(100% + calc(${theme.layout.spacing.standard} * 2));
	max-width: ${theme.layout.container.maxWidth};
	margin: 0 -${theme.layout.spacing.standard};
	border-top: 1px solid #C9CED9;
`;

const Page = styled.div`
	display: block;
	max-width: ${theme.layout.container.maxWidth};
	margin: auto;

	@media only screen and (min-width: 760px) {
		display: flex;
		justify-content: space-between;
		padding: 30px;
	}
`;

const PageContent = styled.div`
	flex-grow: 1;
	display: flex;
	flex-direction: column;

	.page-content__container {
		width: 100%;
	}

	padding-bottom: ${theme.layout.spacing.large};

`;

const LogoWrapper = styled.div`
	align-items: center;
	display: flex;
`;
export interface IFeaturedContainerProps {
	rightHandContent?: React.ReactNode;
	children?: React.ReactNode;
}

export const FeaturedContainer: React.FC<IFeaturedContainerProps> = (props) => {
	const { children, rightHandContent } = props;

	return (
		<PageBody>
			<PageWrapper bg={backgroundStyles.empty}>
				<PageHeaderContent>
					<LogoWrapper>
						<Logo type="full" variant="lightbg" height={24}/>
					</LogoWrapper>
					{rightHandContent ? rightHandContent : null}
				</PageHeaderContent>
				<BottomWrapper>
				</BottomWrapper>
				<Page>
					<PageContent>
						{children}
					</PageContent>
				</Page>
			</PageWrapper>
		</PageBody >
	);
};
